<header class="header">
  <nav class="navbar-container">
    <div class="navbar-brand-container" *ngIf="this.featureFlagService.isFFEqual('qs_phonenumber_ff', 'hide_phonenumber_version')">
      <a href="/" class="navbar-brand">
        <img src="assets/logos/loansLogo.png" alt="loansLogo" width="150px" />
      </a>
    </div>
    <app-phone-contact *ngIf="this.featureFlagService.isFFEqual('qs_phonenumber_ff', 'show_phonenumber_version')"></app-phone-contact>
  </nav>
</header>
